/*
  Remembers when a customer switches off a preselected cart-drawer upsell (e.g. Shipping Protection).
  The theme re-adds preselected upsells on every page load, so the choice is stored in the hidden cart
  attribute "_declined_upsells" (",handle1,handle2,") and snippets/upsell-block.liquid renders those
  upsells as not selected.
*/
(function () {
  if (window.__fbmUpsellMemory) return;
  window.__fbmUpsellMemory = true;

  var KEY = '_declined_upsells';
  var queue = Promise.resolve();

  function save(handle, declined) {
    queue = queue.then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var list = String((cart.attributes && cart.attributes[KEY]) || '').split(',').filter(Boolean);
          var has = list.indexOf(handle) !== -1;
          if (declined === has) return;
          list = declined ? list.concat(handle) : list.filter(function (h) { return h !== handle; });
          var attrs = {};
          attrs[KEY] = list.length ? ',' + list.join(',') + ',' : '';
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .catch(function () { /* the toggle itself still works; only the memory is skipped */ });
    });
  }

  // The toggle makes the theme send /cart/change or /cart/add. Saving the attribute at the same time races
  // with it (Shopify keeps the older cart and the item comes back), so wait until that request has finished.
  var pending = null;
  var fallback = null;
  function flush() {
    clearTimeout(fallback);
    if (!pending) return;
    var p = pending;
    pending = null;
    save(p.handle, p.declined);
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = String((input && input.url) || input || '');
    var res = origFetch.apply(this, arguments);
    if (pending && /\/cart\/(change|add|update)(\.js)?(\?|$)/.test(url)) {
      res.then(function () { setTimeout(flush, 150); }, function () { setTimeout(flush, 150); });
    }
    return res;
  };

  // Capture phase: read the state before the theme flips it
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.upsell-toggle-btn');
    var up = btn && btn.closest('cart-drawer-upsell[data-toggle="true"][data-handle]');
    if (!up) return;
    pending = { handle: up.dataset.handle, declined: up.dataset.selected === 'true' };
    clearTimeout(fallback);
    fallback = setTimeout(flush, 4000);
  }, true);
})();
